// extracted by mini-css-extract-plugin
export var label = "_ar-1";
export var reminder = "_ar-0";